import { type Theme } from "@mui/material"
import { OfferItemTheme } from "core/themes/src/definitions/components.types"

export const createOfferItemTheme = (_: Theme): OfferItemTheme => ({
    styleOverrides: {
        erp: {
            flexDirection: "row",
            justifyContent: "space-between",
        },
        erpAvailabilities: {
            ".erp-info__availability__wrapper, .availability-icon-with-tour": {
                minWidth: 0,
            },
        },
        erpPrices: {
            ".price__group__wrapper": {
                flexDirection: "column",
            },
            ".tk-erp .erp-info-prices .price--two-column": {
                flexDirection: "row",
                gap: 4,
                alignItems: "center",
                "> .text": {
                    fontSize: "1rem",
                },
            },
        },
    },
})
